import { Colors } from "../../modules/Colors";

interface IProps {
  period: any;
  showNext: boolean;
}

const DashBoardStatusIndicator = ({ period, showNext }: IProps) => {
  const percentage = Math.round((period.noOfBuildingsFinished / period.noOfBuildings) * 100);
  const bgColor = percentage === 0 || period.noOfBuildings === 0 ? Colors.GrayLight : percentage === 100 ? Colors.GreenMedium : Colors.YellowMedium;
  return (
    <div style={{ position: "relative" }}>
      <div className="text-end " style={{ position: "absolute", width: "100%", top: "50%", left: 15 }}>
        {showNext ? " >" : ""}
      </div>
      <div className="card text-center defaultCard">
        <div className="card-header justify-content-center">
          <small className="text-muted">
            <div>{period.periodName}</div>
            <div>{period.yearName}</div>
          </small>
        </div>
        <div className="card-body">
          {/* <h5 className="card-title">Sommar</h5> */}
          <div className="card-text">
            <div>{period.noOfBuildingsFinished + " klara"}</div>
            <div>{period.noOfBuildings + " totalt"}</div>
          </div>
        </div>
        <div className="card-footer fs-5 justify-content-center" style={{ backgroundColor: bgColor }}>
          {(period.noOfBuildings ? percentage : 0) + "% klar"}
        </div>
      </div>
    </div>
  );
};

export default DashBoardStatusIndicator;
